$(document).ready(function () {
  // Sticky Bars Js
  $(".ctm_multicol_slider").owlCarousel({
    loop: false,
    margin: 30,
    nav: true,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  });

  var owl = $(".owl-carousel");
  owl.owlCarousel();
  $(".next-btn").click(function () {
    owl.trigger("next.owl.carousel");
  });
  $(".prev-btn").click(function () {
    owl.trigger("prev.owl.carousel");
  });
  $(".prev-btn").addClass("disabled");
  $(owl).on("translated.owl.carousel", function (event) {
    if ($(".owl-prev").hasClass("disabled")) {
      $(".prev-btn").addClass("disabled");
    } else {
      $(".prev-btn").removeClass("disabled");
    }
    if ($(".owl-next").hasClass("disabled")) {
      $(".next-btn").addClass("disabled");
    } else {
      $(".next-btn").removeClass("disabled");
    }
  });

  // Video Popup Js

  $(document).on("click", ".gallery_video_show", function () {
    if($(this).closest(".gallery__item").length > 0){
      var ths_video = $(this)
        .closest(".gallery__item")
        .find(".video_ctm_gl_main")
        .attr("data-video");
      $(this)
        .closest(".gallery__item")
        .find(".youtube_prouct_gallery_video")
        .attr("src", ths_video);
      $(this).closest(".gallery__item").find(".video_ctm_gl_main").show();
    }
    else{
      var ths_video = $(this)
      .closest(".image-overlay")
      .find(".video_ctm_gl_main")
      .attr("data-video");
      $(this)
        .closest(".image-overlay")
        .find(".youtube_prouct_gallery_video")
        .attr("src", ths_video);
      $(this).closest(".image-overlay").find(".video_ctm_gl_main").show();
    }
  });

  $(document).on("click", ".close_gl_video", function () {
    if($(this).closest(".gallery__item").length > 0){
      $(this)
      .closest(".gallery__item")
      .find(".youtube_prouct_gallery_video")
      .attr("src", "");
    }
    else{
      $(this)
      .closest(".image-overlay")
      .find(".youtube_prouct_gallery_video")
      .attr("src", "");
    }
    $(".video_ctm_gl_main").hide();
    $(".page_ctm_main_popup").hide();
  });

  // $(document).on("click", ".gallery_video_show", function () {
  //   var ths_video = $(this)
  //     .closest(".gallery__item")
  //     .find(".video_ctm_gl_main")
  //     .attr("data-video");
  //   $(this)
  //     .closest(".gallery__item")
  //     .find(".youtube_prouct_gallery_video")
  //     .attr("src", ths_video);
  //   $(this).closest(".gallery__item").find(".video_ctm_gl_main").show();
  // });

  // $(document).on("click", ".close_gl_video", function () {
  //   $(this)
  //     .closest(".gallery__item")
  //     .find(".youtube_prouct_gallery_video")
  //     .attr("src", "");
  //   $(".video_ctm_gl_main").hide();
  //   $(".page_ctm_main_popup").hide();
  // });

  // Signup popup js
  $(document).on("click", "a.head_show_popup", function () {
    $(".ctm_signup_pop").attr("open", "open");
  });

  // Page Popup Js
  $("span.page_popup_main a").on("click", function () {
    $(".page_ctm_main_popup").show();
  });

  // Tab Section Js
  $(".itg_tab_list h3").click(function (e) {
    var tabName = $(this).attr("data-id");
    $(this).addClass("active_tabs").siblings().removeClass("active_tabs");
    $(this)
      .closest(".itg_tab_content_wrpr")
      .find(".itg_tab_details .itg_tab_content")
      .each(function () {
        var tabName_box = $(this).attr("data-id");
        if (tabName_box == tabName) {
          $(this).addClass("itg_active_content");
        } else {
          $(this).removeClass("itg_active_content");
        }
      });
  });

  if ($(window).width() < 767) {
    $(".ctm_gallery_slides:not(.ctm_gallery_slides_noslider)").slick({
      infinite: false,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
});
//predective search Js
$(document).ready(function () {
  var curr = $(".hidden_currency_value").attr("value");

  $('#main-searchMobileNav form.search-header').css("position", "relative").each(function () {
      var input = $(this).find('.mobile_search_itg[name="q"]');

      $(document).on("change keyup", ".mobile_search_itg", function () {
        var term = $(this).val().trim();
        var stringterm = $(this).val().trim().toLowerCase();
        var form = $(this).closest("form");
        var resultsList = form.find(".search-results-mob");
        if (term != "") {
          $(".search-results-mob").addClass("show");

        var search_var_set_ck = window.theme.routes.predictiveSearch;
        var search_var_set_ck = search_var_set_ck.replace('/suggest','');
        console.log(search_var_set_ck.replace('/suggest',''));

       fetch(`${search_var_set_ck}?q=${stringterm}`).then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.text();
    }).then(htmlContent => {
        var grid_ = new DOMParser().parseFromString(htmlContent, 'text/html').querySelector('.product-grid').innerHTML;
        if (!grid_) {
            resultsList.html('<li><span class="title">No results.</span></li>');
        } else {
            resultsList.html(grid_);
        }
    }).catch(error => {
        console.error('Error fetching HTML content:', error);
    });

          
          // jQuery.getJSON(`/search?q=${stringterm}`).done(function (response) {
          //   console.log(response);
          //   var grid_ = response.find('.product-grid').html();
          //   if (grid_ == '') {
          //     resultsList.html(
          //         '<li><span class="title">No results.</span></li>'
          //       );
          //   } else {
          //      resultsList.html(
          //         grid_
          //       );
          //   }
          //   console.log(response);
          //     //resultsList.empty();
          //     // var productSuggestions = response.resources.results.products;
          //     // // console.log(productSuggestions);
          //     // var shop_symbol = $(".hidden_money_value").attr("value");
          //     // console.log(shop_symbol);
          //     // shop_symbol = shop_symbol.trim();
          //     // if (
          //     //   shop_symbol.substring(shop_symbol.length - 1) !== "}" &&
          //     //   shop_symbol.substring(shop_symbol.length - 1).length > 0
          //     // ) {
          //     //   shop_symbol = shop_symbol.substring(shop_symbol.length - 1);
          //     // } else {
          //     //   shop_symbol = shop_symbol.substring(0, 1);
          //     // }

          //     // if (productSuggestions.length > 0) {
          //     //   $.each(productSuggestions, function (index, item) {
          //     //     var link = $("<a></a>").attr("href", item.url);
          //     //     link.append(
          //     //       '<span class="thumbnail"><img src="' +
          //     //         item.image +
          //     //         '" /></span>'
          //     //     );
          //     //     //  link.append('<span class="ctm_model_number">' + item.product.metafields.custom.product_model_number + '</span>');
          //     //     // link.append('<span class="modal_number">'+item.tags[0]+'</span>');
          //     //     link.append('<span class="title">' + item.title + "</span>");
          //     //     link.append(
          //     //       '<span class="price">' +
          //     //         shop_symbol +
          //     //         item.price +
          //     //         curr +
          //     //         "</span>"
          //     //     );
          //     //     link.wrap("<li></li>");
          //     //     resultsList.append(link.parent());
          //     //   });
          //     //   resultsList.fadeIn(100);
                
          //     // } else {
          //     //   resultsList.html(
          //     //     '<li><span class="title">No results.</span></li>'
          //     //   );
          //     // }
          //   });

          
        } else {
          setTimeout(function () {
            resultsList.html('<li><span class="title">No results.</span></li>');
            $(document).find(".search-results-mob").hide();
            $(".search-results-mob").removeClass("show");
          }, 800);
        }
      });
    });

  $("body").bind("click", function () {
    $(".search-results-mob").hide();
    $(".search-results-mob").removeClass("show");
  });
});

$(document).ready(function () {
  $(document).on(
    "click",
    "input.mobile_search_itg.search-header__input.search__input",
    function () {
      $(this).addClass("checkinput");
      $(".mobile_search .main-search__suggestions").show();
      $(".overlay_mobile_nav").addClass("active_overlay");
      $(".mobile-navigation-drawer.ctm_head_show").addClass(
        "head_show_overlap"
      );
      $(".ctm_predective_overflow").addClass("search_show_overlap");
    }
  );

  $("input.mobile_search_itg.search-header__input.search__input").on(
    "keyup",
    function () {
      var ths_val = $.trim($(this).val());
      if (ths_val == "") {
        $(document).find(".main-search__suggestions").show();
        $(document).find(".search-results-mob").hide();
        $(".mobile_search .main-search__suggestions").hide();
        $(".overlay_mobile_nav").removeClass("active_overlay");
        $(".mobile-navigation-drawer.ctm_head_show").removeClass(
          "head_show_overlap"
        );
        $(".ctm_predective_overflow").removeClass("search_show_overlap");
        $(".mobile_search button.main-search__button").show();
      } else {
        $(".overlay_mobile_nav").addClass("active_overlay");
        $(".mobile-navigation-drawer.ctm_head_show").addClass(
          "head_show_overlap"
        );
        $(".ctm_predective_overflow").addClass("search_show_overlap");
        $(".mobile_search button.main-search__button").hide();
      }
    }
  );

  // Navigation Show Js
  $("span.show_nav_listctm svg").on("click", function () {
    $("input.mobile_search_itg.search-header__input.search__input").val("");
    $(document).find(".search-results-mob").hide();
    $(".mobile_search .main-search__suggestions").hide();
    $(".overlay_mobile_nav").removeClass("active_overlay");
    $(".mobile-navigation-drawer.ctm_head_show").removeClass(
      "head_show_overlap"
    );
    $(".ctm_predective_overflow").removeClass("search_show_overlap");
    $(".mobile_search button.main-search__button").show();
  });

  // Specs Js Start
  $("a.ctm_specs_btn").on("click", function () {
    $(this).addClass("current_active_a");
    $(".specs_main_spacing").addClass("ctm_specs_show");
  });

  $(".mobile_stickybar .sticky_drop_second span").on("click", function () {
    $(document).find(".sticky_buy_right").removeClass("active_dropdown");
    $(this).toggleClass("active_buy");
    //$('.mobile_stickybar .sticky_buy_right.sticky_drop_down').slideToggle('active');
    $(".mobile_stickybar .sticky_buy_right.sticky_drop_down").toggle(500);
    $("body").addClass("ctm-menu-opn");
    setTimeout(function () {
      $("body").removeClass("ctm-menu-opn");
    }, 1000);
  });
  $(".mobile_stickybar .sticky_buy_right.sticky_drop_down a").on(
    "click",
    function () {
      $("body").removeClass("product_explore_menu");
      $(".mobile_stickybar .sticky_drop_second span").addClass("active_buy");
      $(document)
        .find(".mobile_stickybar .sticky_drop_second span")
        .removeClass("active_buy");
      //$('.sticky_buy_right.sticky_drop_down').slideToggle('active');
      $(".sticky_buy_right.sticky_drop_down").toggle("slow");
    }
  );
  function addParameterToURL(param){
    _url = location.href;
    _url += (_url.split('?')[1] ? '&':'?') + param;
    return _url;
    }
  $(".sticky_buy_right a.ctm_specs_btn").on("click", function () {
    $(
      ".hotspot_section, .section-image-with-text-overlay, .section-rich-text, .ctm_multicolum_nw, .ctm_gallery_nw, .section-featured-collection, .section-image-with-text"
    ).addClass("hidden_sections");
    $("a.ctm_overview_btn").removeClass("current_active_a");
    
    const urlParams2 = new URLSearchParams(window.location.search);
    if (urlParams2.has('specs')) {
    } else {
      window.history.pushState('page2', 'Title', addParameterToURL('specs'));
    }
    
  });

  $(".sticky_buy_right a.ctm_overview_btn").on("click", function () {
    $(
      ".hotspot_section, .section-image-with-text-overlay, .section-rich-text, .ctm_multicolum_nw, .ctm_gallery_nw, .section-featured-collection, .section-image-with-text"
    ).removeClass("hidden_sections");
    $(".specs_main_spacing").removeClass("ctm_specs_show");
    $("a.ctm_specs_btn").removeClass("current_active_a");
    $(this).addClass("current_active_a");

    window.history.replaceState({}, '', window.location.pathname);
  });

  if ($(window).width() < 767) {
    $(".ctm_specs_btn").click(function () {
      $("html, body").animate(
        {
          scrollTop: $(".ctms_specs_section").offset().top - 300,
        },
        1000
      );
    });

    $("a.ctm_overview_btn").click(function () {
      $("html, body").animate(
        {
          scrollTop: $("#overview_id").offset().top - 300,
        },
        1000
      );
    });
  } else {
    $(".ctm_specs_btn").click(function () {
      $("html, body").animate(
        {
          scrollTop: $(".ctms_specs_section").offset().top - 150,
        },
        1000
      );
    });

    $("a.ctm_overview_btn").click(function () {
      $("html, body").animate(
        {
          scrollTop: $("#overview_id").offset().top - 150,
        },
        1000
      );
    });
  }

  $("a.ctm_star_icons").on("click", function () {
    var product_url = $(this).attr("data-redirect");
    window.location.href = product_url;
  });
});

$(window).on("scroll", function () {
  if ($(".quantity-submit-row__submit").length) {
    var getHeight = $(".quantity-submit-row__submit").offset().top - 50;
    var winSrl = $(window).scrollTop();
    var winHeight = $(window).innerHeight();
    var oldHeight = getHeight - winHeight;
    var mainHeight = oldHeight + winHeight;
    if (oldHeight > winSrl) {
      $(".sticky_btn").show();
    } else {
      $(".sticky_btn").hide();
      $(".sticky_btn").removeClass("show");
      if (mainHeight < winSrl) {
        $(".sticky_btn").show();
        $(".sticky_btn").addClass("show");
      }
    }
  }
});

// itg js
$("buy-header").append($(".sticky_section"));
$(window).on("load", function () {
  $(window).scroll(function () {
    if (!$("body").hasClass("ctm-menu-opn")) {
      $(document).find(".sticky_buy_right.sticky_drop_down").fadeOut();
      $(document)
        .find(".mobile_stickybar .sticky_drop_second span")
        .removeClass("active_buy");
      $("body").addClass("product_explore_menu");
    }
  });
});

// ITG js

$(document).ready(function () {
  if (window.sticky) {
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 100) {
        $(".shopify-section.section-header").addClass("fixed-header");
        $(".sticky_section").addClass("fixed_sticky_bar");
      } else {
        $(".shopify-section.section-header").removeClass("fixed-header");
        $(".sticky_section").removeClass("fixed_sticky_bar");
      }
    });

    var headerHeight = $(".section-header").height();
    $(document)
      .find(".sticky_btn")
      .css("top", headerHeight + "px");
  } else {
    $(document).find(".sticky_btn").css("top", "0px");
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 100) {
        $(document).find(".sticky_section").addClass("sticky_header_section");
      } else {
        $(document)
          .find(".sticky_section")
          .removeClass("sticky_header_section");
      }
    });
  }
});

$(document).ready(function () {
  $(window).scroll(function () {
    var headerHeight = $(".section-header").height();
    $(".sticky_section").css("top", headerHeight);
  });
});

function pgshow() {
  var elId = window.location.hash.substring(1);
  if (elId) {
    var el = document.getElementById(elId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
}

window.addEventListener("pageshow", pgshow);

$(document).on(
  "click",
  ".custom_location_main .disclosure__toggle",
  function () {
    $(this).toggleClass("active");
    $(document)
      .find(".custom_location_main .disclosure-list")
      .toggleClass("active");
  }
);

// ITG custom slider section js

$(document).ready(function () {
  $(".time_line").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    dots: false,
    adaptiveHeight: false,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><svg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M13 25L1 13L13 1' stroke='black' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><svg width='14' height='26' viewBox='0 0 14 26' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 25L13 13L1 1' stroke='black' stroke-width='0.83' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    asNavFor: ".Image_multi",
  });
  $(".Image_multi").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".time_line",
    arrows: false,
    centerMode: true,
    centerPadding: "5px",
    infinite: true,
    draggable: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

$(document).on('afterChange', '.time_line',function(event, slick, currentSlide, nextSlide){
    var imgHeight = $('.main_image_timer.slick-slide.slick-active .main_images_years_time').height();
    imgHeight = imgHeight / 2;
    $('.ctm_tab_main_timer .main_time_slider .slick-next, .ctm_tab_main_timer .main_time_slider .slick-prev').css('top',imgHeight+'px');
});


$(document).on("click", ".close_gl_video", function () {
  if ($(".prouct_gallery_video").length > 0) {
    $(".prouct_gallery_video")[0].pause();
  }
});

$(document).on("click", ".close_gl_video", function () {
  $(document).find(".page_ctm_main_popup").hide();
});


$(document).on('click','.custom_addto_cart',function(e){
  e.preventDefault();
  var qty = 1;
  var variantId = $(this).parents('form').find('[name="id"]').val();
  
  $.ajax({
    url:'/cart/add.js',
    type:'POST',
    data:'quantity=' + qty + '&id=' + variantId,
    dataType:'json',
    context:this,
    success:function(res){
      if(window.checkDrawer == 'drawer'){
        document.dispatchEvent(
          new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
        );
      document.querySelector('.js-cart-drawer').open();
      }else{
        location.href='/cart';
      }
    },
    error:function(error){
      console.log(error);
    }
  });
});

async function generatePDF(pdf_name) {
      
       const { jsPDF } = window.jspdf;
      const doc = new jsPDF({
            orientation: 'portrait', // Portrait mode
            unit: 'px',               // Use pixels for better control
            format: 'a4'              // A4 page size
        });

        const content = document.getElementById('print__pdf');
        
        // Use jsPDF html() method to convert HTML to PDF
        await doc.html(content, {
            callback: function (doc) {
                doc.save(pdf_name+'.pdf');
                $('.dowload_pdf_btn').attr('disabled',false);
            },
            x: 10,
            y: 10,
            html2canvas: {
                scale: 0.7,  // Adjust scale for better fit
            },
            width: 600,    // Make sure to match the content's width to page
            windowWidth: 600 // Corresponding window width to render content properly
        });
    console.log('testttt')
   }
$(document).on("click", ".dowload_pdf_btn", function () {
     $(this).attr('disabled',true);
     generatePDF($(this).attr('data-name'));
  
});

$(document).ready(function(){
    // Get the current URL's query string
    const urlParams = new URLSearchParams(window.location.search);
    
    // Check if the 'specs' parameter exists
    if (urlParams.has('specs')) {
      if( $(".sticky_buy_right a.ctm_specs_btn").length > 0){
         $(".sticky_buy_right a.ctm_specs_btn").trigger('click');
      }
    } else {
        console.log('The specs parameter is not in the URL.');
    }
})
